import {IModalService} from "angular-ui-bootstrap";
import {IvAccountOpeningDialog} from "../dialog/IvAccountOpeningDialog";

export class IvAccountOpeningService {
    public static id = "ivAccountOpeningService";

    /** @ngInject */
    constructor(private readonly $uibModal: IModalService) {
    }

    public start() {
        const options = {
            component: IvAccountOpeningDialog,
            controllerAs: "ctrl",
            size: "fs",
            // windowClass: "accOpenWidth",
            resolve: {}
        };

        const modalInstance = this.$uibModal.open(options);
    }
}
